<template>
<div class="chapter">
<div class="inner_page">
<h1 class="Chapter_head">Table of Contents</h1>
<h2 class="ornaments"><img alt="" src="OEBPS/images/common.png"/></h2>
<p class="Body_nonindent" id="cvi"><a href="#/OEBPS/cvi.htm">Cover</a></p>
<p class="Body_nonindent" id="tp"><a href="#/OEBPS/tp.htm">Title Page</a></p>
<p class="Body_nonindent" id="fm"><a href="#/OEBPS/fm.htm">Toronto, Upper Canada, 1837</a></p>
<p class="Body_nonindent" id="c12"><a href="#/OEBPS/c12.htm">December 1837</a></p>
<p class="Body_nonindent" id="c01"><a href="#/OEBPS/c01.htm">January 1838</a></p>
<p class="Body_nonindent" id="c02"><a href="#/OEBPS/c02.htm">February 1838</a></p>
<p class="Body_nonindent" id="c03"><a href="#/OEBPS/c03.htm">March 1838</a></p>
<p class="Body_nonindent" id="c04"><a href="#/OEBPS/c04.htm">April 1838</a></p>
<p class="Body_nonindent" id="c05"><a href="#/OEBPS/c05.htm">May 1838</a></p>
<p class="Body_nonindent" id="c06"><a href="#/OEBPS/c06.htm">June 1838</a></p>
<p class="Body_nonindent" id="c07"><a href="#/OEBPS/c07.htm">July 1838</a></p>
<p class="Body_nonindent" id="c08"><a href="#/OEBPS/c08.htm">August 1838</a></p>
<p class="Body_nonindent" id="c09"><a href="#/OEBPS/c09.htm">September 1838</a></p>
<p class="Body_nonindent" id="c10"><a href="#/OEBPS/c10.htm">October 1838</a></p>
<p class="Body_nonindent" id="bm1"><a href="#/OEBPS/bm1.htm">What Became of Them All</a></p>
<p class="Body_nonindent" id="his"><a href="#/OEBPS/his.htm">Historical Note</a></p>
<p class="Body_nonindent" id="image"><a href="#/OEBPS/image.htm">Images and Documents</a></p>
<p class="Body_nonindent" id="cred"><a href="#/OEBPS/cred.htm">Credits</a></p>
<p class="Body_nonindent" id="ded"><a href="#/OEBPS/ded.htm">Dedication</a></p>
<p class="Body_nonindent" id="ata"><a href="#/OEBPS/ata.htm">About the Author</a></p>
<p class="Body_nonindent" id="cop"><a href="#/OEBPS/cop.htm">Copyright</a></p>
<p class="Body_nonindent" id="book"><a href="#/OEBPS/book.htm">Books in the Dear Canada Series</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2cd2138c